import AuditTrail from "../audit.trail";

export const InputLog = (WrappedComponent) => (props) => {
  const { onBlur, onClick, onChange, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          let data = Object.assign({tag: 'input', event: action, label: props.label? props.label : ''}, eventParams);
          if (props.valueRange) {
              data.valueRange = props.valueRange;
          }
          AuditTrail.sendLog(event, data);
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onBlur={(context) => {
            onLog(event, 'onBlur', eventParams);
            if (props.onBlur) {
                props.onBlur(context);
            }
        }}
        onClick={(context) => {
            onLog(event, 'onClick', eventParams);
            if (props.onClick) {
                props.onClick(context);
            }
        }}
        onChange={(context) => {
            if (props.onChange) {
                props.onChange(context);
            }
        }}
    />
  );
};
